export const ADD_SALE_NOTIFICATION = 'ADD_SALE_NOTIFICATION';
export const REMOVE_SALE_NOTIFICATION = 'REMOVE_SALE_NOTIFICATION';
